import React from 'react'
import DownloadCSV, { fileNameWithDate } from '../../../io/download-csv'
import DownloadButton from '../../../ui/download-button'


const apiPath = (record) => (
  `${process.env.REACT_APP_API_HOST}/api/${record.type}s/${record.type_id}/missing-approvals`
)

export const ExportOutstandingCWAs = ({ remote_request, record }) => {
  const {
    loading, errors
  } = remote_request.state

  return (
    <DownloadButton
      loading={loading}
      errors={errors}
      onClick={() => remote_request.submit({
        url: apiPath(record),
        method: 'GET',
        fileName: fileNameWithDate(`${record.name} Outstanding CWAs`)
      })}
    >
      Outstanding CWAs
    </DownloadButton>
  )
}

export default DownloadCSV(ExportOutstandingCWAs)



// WEBPACK FOOTER //
// ./src/gov-registrations/details/export-missing-approvals/index.js